import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const UserShow = ({
  name,
  phone,
  phone_area_code,
  phone_alt,
  email,
}) => (
  <>
    <Grid item md={4}>
      <Typography className="user-card-name" variant="body2">
        {name}
      </Typography>
    </Grid>
    <Grid item md={4}>
      {email && (
        <Typography variant="body2">
          <FontAwesomeIcon className="signs-span" icon="at" />
          {email}
        </Typography>
      )}
    </Grid>

    <Grid item md={4}>
      {phone && (
        <Typography variant="body2">
          <FontAwesomeIcon className="signs-span" icon="phone" />
          {phone_area_code == null || phone_area_code === "351"
            ? ""
            : "(00" + phone_area_code + ")"}{" "}
          {phone} {phone_alt && <span> &mdash; {phone_alt}</span>}
        </Typography>
      )}
    </Grid>
  </>
);
